export function saltarBeneficiarios(observations) {
  return observations && observations.includes("SA");
}

export function saltarDependientes(observations) {
  return observations && (observations.includes("SD") || observations.includes("VI"));
}
